import styled from 'styled-components';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { signInAPI } from '../actions';
import { Navigate } from 'react-router-dom';

const Login = (props) => {
    return(
        <Container>
            {props.user && <Navigate to = "/home" />}
            <Nav>
                <a href ="/">
                    <img src = "/images/login-logo.svg" alt =""></img>
                </a>
                <div>
                    <Join>Join Now</Join>
                    <SignIn>Sign In</SignIn>
                </div>
            </Nav>
            <Section>
                <Hero>
                    <h1>Welcome to your professional community</h1>
                    <img src="/images/login-hero.svg" alt=""></img>
                </Hero>
                <Form>
                    <Google onClick = {props.signIn}>
                        <img src="/images/google.svg" alt =""></img>
                        Sign in with Google
                    </Google>
                </Form>
            </Section>
        </Container>
    )
};

const Container = styled.div`
    padding: 0px;
`;
const Nav = styled.nav`
    max-width: 1128px;
    margin: auto;
    padding: 12px 0 16px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;   /*why there is space between linkedin, join now, and sign */
    flex-wrap: nowrap;               /*why linkedin, join now, and sign in are in one line*/
    
    & > a {
        width: 135px;
        height: 34px;
        @media (max-width: 768px){   /*for phone*/
            padding: 0 5px;
        };
    }
`;

const Join = styled.a`
    font-size: 16px;
    padding: 10px 12px;
    text-decoration: none;
    border-radius: 4px;
    color: rgba(0,0,0,0.6);
    margin-right: 12px;
    &:hover {
        background-color: rgba(0,0,0,0.08);
        color: rgba(0,0,0,0.9);
        text-decoration: none;
        cursor: auto;
    }
`;

const SignIn = styled.a`
    box-shadow: inset 0 0 0 1px #0a66c2;
    color: #0a66c2;
    border-radius: 24px;
    transition-duration: 167ms;
    font-size: 16px;
    font-weight: 600;  /*thickness or boldness*/
    line-height: 40px;
    padding: 10px 24px;
    text-align: center;
    background-color: rgba(0,0,0,0);
    &:hover {
        background-color: rgba(112, 181, 249, 0.15);  
        color: #0a66c2;
        text-decoration: none;
        cursor: auto;
    }
`;

const Section = styled.section`
    align-content: start;
    display: flex;
    min-height: 700px;
    padding-bottom: 130px;  /*if you add anything below the section, it doesnt get added immediately attached to the section. */
    padding-top: 40px;
    padding: 60px 0;
    position: relative;
    flex-wrap: wrap; /* allows the image to come to the centre or align when the screen gets smaller*/
    width: 100%;
    max-width: 1128px;
    align-items: center;
    margin: auto;
    @media (max-width:768px){
        margin: auto;
        min-height: 0px;
    }
`;

const Hero = styled.div`
    width: 100%;
    h1{
        padding-bottom: 0px;
        width: 55%;
        font-size: 56px;
        color: #2977c9;
        font-weight: 200;
        line-height: 70px; /*spacing between the text */
        @media (max-width: 768px){
            text-align: center;
            font-size: 20px;
            width: 100%;
            line-height: 2;
        }

    }
    img {
        /*z-index: -1; if text overlaps, then text always on top*/
        width: 700px;
        height: 670px;
        position: absolute;
        bottom: -2px;
        right: -150px;
        @media (max-width: 768px){
            top:230px;
            width: initial;
            position: initial;
            height: initial;
        }


    }
`;
const Form = styled.div`
    margin-top: 100px;
    width: 408px;
    @media (max-width: 768px){
        margin-top: 20px;
    }
`;

const Google = styled.button`
    display: flex;
    justify-content: center; /*horizhontally center things */
    background-color: #fff;
    align-items: center;
    height: 56px;
    width: 100%;
    border-radius: 28px;
    box-shadow: inset 0 0 0 1px rgba(0 0 0 / 60%), 
        inset 0 0 0 2px rgba(0 0 0 / 0%) inset 0 0 0 1px rgba(0 0 0 / 0);
    vertical-align: middle;
    z-index: 0;
    transition-duration: 167ms;
    font-size: 20px;
    color: rgba(0,0,0,0.6);
    &:hover {
        background-color: rgba(207,207,207,0.25);
        color: rgba(0,0,0,0.75);
    }
`;

const mapStateToProps = (state) => { /*you wouldnt have to use this if you use redux toolkit */
    return {
        user: state.userState.user,
    };
};

const mapDispatchToProps = (dispatch) => ({
    signIn: () => dispatch(signInAPI()), /*Google component on click calls signIn */
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);

//after the connect line, we installed firebase, firebase-tools, redux-thunk
//redux is like db on the frontend. stores info there